import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';

import { Typography } from '@mui/material';
import { allEstudiantesDocenteAction } from '../../../control_estudios/estudiantes/EstudiantesAction';
import {
  ALL_ESTUDIANTES_DOCENTE,
  PARAMS_ESTUDIANTES_DOCENTE,
} from '../../../control_estudios/estudiantes/EstudiantesReducer';
import SelectFieldMateriasComponent from '../../../control_estudios/materias/components/SelectFieldMaterias';
import SelectFieldSeccionesComponent from '../../../control_estudios/secciones/components/SelectFieldSecciones';

const FiltrosEstudiantesDocenteComponent = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);
  const docentesStore = Redux.useSelector((state) => state.docentes);

  React.useEffect(() => {
    const payload = {
      idEntidad: entidadesStore.activo.id,
    };
    dispatch({ type: PARAMS_ESTUDIANTES_DOCENTE, payload });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (estudiantesStore.paramsEstudiantesDocente.docente) {
      dispatch({
        type: PARAMS_ESTUDIANTES_DOCENTE,
        payload: {
          ...estudiantesStore.paramsEstudiantesDocente,
          idSeccion: null,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estudiantesStore.paramsEstudiantesDocente.docente]);

  const getData = async (p) => {
    if (!p) {
      dispatch({
        type: ALL_ESTUDIANTES_DOCENTE,
        payload: { data: [] },
      });
    }
    const payload = {
      ...estudiantesStore.paramsEstudiantesDocente,
      ...p,
    };
    dispatch({ type: PARAMS_ESTUDIANTES_DOCENTE, payload });

    if (payload.materia && payload.seccion) {
      await allEstudiantesDocenteAction(
        loginStore.isAdminTeacher,
        dispatch,
        docentesStore.activo.id,
        payload,
      );
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <Typography variant="h6" color="initial">
            FILTROS
          </Typography>
        </Grid>
        <Grid item md={12}>
          <SelectFieldMateriasComponent
            isAll={false}
            value={
              estudiantesStore.paramsEstudiantesDocente.materia?.toString() ??
              ''
            }
            data={docentesStore.activo.materias}
            onChange={(materia) => {
              getData({ materia });
            }}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <SelectFieldSeccionesComponent
            id="filtroSecciones"
            value={estudiantesStore.paramsEstudiantesDocente.seccion}
            data={docentesStore.activo.secciones}
            isAll={false}
            onChange={(seccion) => {
              getData({ seccion });
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FiltrosEstudiantesDocenteComponent;
